import { useMutation } from "react-query";
import { validateNutrients } from "../../../components/attributes/lib/attribute-data";

export const useNutritionValidator = () => {
    return useMutation({
        queryKey: ["nutritionValidator"],
        mutationFn: ({ uuid, attribute }) => validateNutrients({ attribute: { [uuid]: attribute } }),
    });
};
